import {
	BuildingOffice2Icon,
	EnvelopeIcon,
	PhoneIcon,
} from '@heroicons/react/24/outline';
import { useAlert } from '../../context/AlertContext';
import { useState } from 'react';
import client from '../../api/client';
import seo from '../../data';
import SocialLinks from '../Global/SocialLinks';
import { Link } from 'react-router-dom';
import GoogleMaps from './GoogleMaps';
import Analytics from '../../utils/Analytics';
import ContactForm from './ContactForm';

export default function Contact({ modal = false }) {
	return (
		<div
			id='contact'
			className='relative isolate bg-gray-50 px-6 py-16 lg:px-8'
		>
			{!modal ? (
				<div className='mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-2'>
					<div className='relative px-4 pb-8 pt-12 lg:pt-16 sm:px-6 lg:static lg:px-8'>
						<div className='mx-auto max-w-xl lg:max-w-lg'>
							<h2 className='text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl'>
								Get a free estimate!
							</h2>
							<p className='mt-6 text-lg text-gray-600'>
								We usually respond within 1 to 2 business days.
							</p>
							<dl className='mt-8 space-y-4 text-base text-gray-600'>
								<div className='flex gap-x-4'>
									<PhoneIcon
										className='h-7 w-6 text-gray-400'
										aria-hidden='true'
									/>
									<a
										href={`tel:${seo.company.phone}`}
										className='hover:text-gray-900'
									>
										{seo.company.phone}
									</a>
								</div>
								<div className='flex gap-x-4'>
									<EnvelopeIcon
										className='h-7 w-6 text-gray-400'
										aria-hidden='true'
									/>
									<a
										href={`mailto:${seo.company.email}`}
										className='hover:text-gray-900'
									>
										{seo.company.email}
									</a>
								</div>
							</dl>
							<SocialLinks dark={true} />
						</div>
					</div>
					<ContactForm modal={modal} />
				</div>
			) : (
				<div>
					<h2 className='text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl'>
						Get a free estimate!
					</h2>
					<p className='mt-6 text-lg text-gray-600'>
						We usually respond within 1 to 2 business days.
					</p>
					<ContactForm modal={modal} />
				</div>
			)}
		</div>
	);
}
